import {Icon} from 'semantic-ui-react';
import PropTypes from 'prop-types';

const ImageGridItem = ({className, selected, src, onClick}) => {
  const classes = [].concat('item', className, selected ? 'highlighted' : 'inactive').join(' ');
  const onClickProxy = !selected ? onClick : undefined;
  return (
    <li className={classes} style={{
      backgroundImage: `url('${src.replace(/\s/g, '%20')}')`,
      backgroundSize: 'cover',
    }} onClick={onClickProxy}>
      {selected &&
        <div className="tick">
          <Icon name="check" color="blue" size="small" fitted bordered={false}/>
        </div>
      }
    </li>
  );
};

ImageGridItem.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
  src: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default ImageGridItem;
